import type { VFC } from 'react';

import { VulnIgnoreReasonDescriptions } from '../../../../../shared/issuesV2';
import { selectOptionFactory } from '../../../../utils';
import { FilterPanel } from '../../../generic/Filter';
import FilterCardMultiSelect from '../../../generic/Filter/FilterCardMultiSelect';
import IgnoreReasonTitle from '../../../shared/vulns/IgnoreReasonTitle';
import type { VulnIgnoreReason } from '../../../../../shared/issuesV2';
import type { SelectOption } from '../../../../types';

type Props = {
  onSet(values: string[]): void;
  selectedOptions?: string[];
};

/**
 * Add a series of checkboxes for filtering Vuln Issues by "Ignore Reason".
 */
const IgnoreReasonFilter: VFC<Props> = ({ selectedOptions, onSet }) => {
  const options = Object.entries(VulnIgnoreReasonDescriptions).map(([ignoreReason, label]) => {
    return selectOptionFactory(ignoreReason, label);
  });

  const selectedOptionsDropdownValues = (selectedOptions || []).reduce((acc, ignoreReason) => {
    if (VulnIgnoreReasonDescriptions[ignoreReason as VulnIgnoreReason]) {
      acc.push(selectOptionFactory(ignoreReason, VulnIgnoreReasonDescriptions[ignoreReason as VulnIgnoreReason]));
    }
    return acc;
  }, [] as SelectOption[]);

  return (
    <FilterPanel>
      <FilterCardMultiSelect
        label={<IgnoreReasonTitle title="Ignore Reason" />}
        placeholder="Select one or more..."
        options={options}
        values={selectedOptionsDropdownValues}
        onChange={(selectedValues) => {
          if (selectedValues.length) {
            onSet(selectedValues.map(o => o.value));
          } else {
            onSet([]);
          }
        }}
        testId="issues-vuln-ignore-reason"
      />
    </FilterPanel>
  );
};

export default IgnoreReasonFilter;
